import React from 'react'
import { Grid, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import ClearIcon from '@mui/icons-material/Clear'

export interface IFilterMapped {
  page?: number
  perPage?: number
  search?: string
}

interface FilterGroupProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
}

const ProductGroupFilter = (props: FilterGroupProps) => {
  const { filter, onFilterChange, onSearch } = props
  const { page, perPage, search } = filter

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={8}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          label={'ชื่อกลุ่มสินค้า'}
          fullWidth
          id="search"
          name="search"
          variant="filled"
          value={search ?? ''}
          onChange={(e) =>
            onFilterChange({ ...filter, search: e.target.value })
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSearch(filter)
            }
          }}
        />
      </Grid>
      <Grid item xs={12} lg={2}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={12} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onFilterChange({ page, perPage, search: undefined })
            onSearch({ page, perPage, search: undefined })
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
    </Grid>
  )
}

export default ProductGroupFilter
